import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/task-catalog/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 *
 * Folder views live under `/folders/` rather than sharing `:idOrAdd` with the form: the two pages
 * need different layout chrome (see the route tree), which a single route leaf can't provide.
 */
export const catalogTasksRoute = defineRoute("/libraries/task-catalog");
export const constraintItemsCatalogRoute = defineRoute("/libraries/task-catalog/constraint-and-allowance-catalog");
export const catalogTaskLaborCostsRoute = defineRoute("/libraries/task-catalog/:globalPlanTaskId/labor-costs");
export const catalogTaskRoute = defineRoute("/libraries/task-catalog/:idOrAdd");
export const catalogTaskFolderRoute = defineRoute("/libraries/task-catalog/folders/:folderId");
